@if (resolvedImageUrl()) {
    <img [src]="resolvedImageUrl()" alt="" class="image" />
} @else if (resolvedInitials()) {
    <span [class]="initialsClass()">{{ resolvedInitials() }}</span>
} @else {
    <ng-icon
        qpx
        style="color: inherit"
        [size]="size() === 'md' ? 'md' : 'sm'"
        [name]="fallbackIcon()"
    />
}
